"use strict";

var KTLayoutAside = function () {
	// Private properties
	var _body;
	var _element;
	var _offcanvasObject;

	// Private functions
	// Initialize
	var _init = function () {

		var offcanvasClass = KTUtil.hasClass(_element, 'aside-offcanvas-default') ? 'aside-offcanvas-default' : 'aside';

		// Initialize mobile aside offcanvas
		_offcanvasObject = new KTOffcanvas(_element, {
			baseClass: offcanvasClass,
			overlay: true,
			closeBy: 'kt_aside_close_btn',
			toggleBy: {
				target: 'kt_aside_mobile_toggle',
				state: 'mobile-toggle-active'
			}
		});

		_initMenuClickHandler();
	}

	var _initMenuClickHandler = function () {
		// Get all menu items with links
		var menuItems = _element.querySelectorAll('.menu-item > .menu-link, .menu-item > a');

		menuItems.forEach(function (item) {
			item.addEventListener('click', function (e) {
				// Only close on mobile or when aside is minimized
				if (window.innerWidth < 992 || KTUtil.hasClass(_body, 'aside-minimize')) {
					// Close the offcanvas
					if (_offcanvasObject) {
						_offcanvasObject.hide();
					}

					// Remove mobile toggle active state
					var toggle = KTUtil.getById('kt_aside_mobile_toggle');
					if (toggle) {
						KTUtil.removeClass(toggle, 'mobile-toggle-active');
					}
				}
			});
		});
	}


	// Public methods
	return {
		init: function (id) {
			_element = KTUtil.getById(id);
			_body = KTUtil.getBody();

			if (!_element) {
				return;
			}

			// Initialize
			_init();
		},

		getElement: function () {
			return _element;
		},

		getOffcanvas: function () {
			return _offcanvasObject;
		},

		isFixed: function () {
			return KTUtil.hasClass(_body, 'aside-fixed');
		},

		isMinimized: function () {
			return (KTUtil.hasClass(_body, 'aside-fixed') && KTUtil.hasClass(_body, 'aside-minimize'));
		},

		isHoverable: function () {
			return (KTUtil.hasClass(_body, 'aside-fixed') && KTUtil.hasClass(_body, 'aside-minimize-hoverable'));
		}
	};
}();



export default KTLayoutAside;